/** Matches typical Laravel `max:10240` (kilobytes) for uploads. */
export const TRADIE_IMPORT_MAX_FILE_BYTES = 10 * 1024 * 1024

/** For `b-form-file` `accept` — CSV and Excel .xlsx only. */
export const TRADIE_IMPORT_ACCEPT =
  '.csv,.xlsx,text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'

/** Shown when the chosen file is not .csv or .xlsx (client-side). */
export const TRADIE_IMPORT_INVALID_TYPE_MESSAGE =
  'Only CSV and XLSX files are allowed.'

/**
 * True for browser `File`, `Blob` with a name (e.g. from file input), or equivalent.
 * Avoid relying only on `instanceof File` — some environments pass Blob or odd objects.
 *
 * @param {*} file
 * @returns {boolean}
 */
export function isTradieImportFileLike(file) {
  if (!file || typeof file !== 'object') return false
  if (typeof file.name !== 'string' || file.name.length === 0) return false
  if (typeof file.size !== 'number') return false
  if (typeof File !== 'undefined' && file instanceof File) return true
  if (typeof Blob !== 'undefined' && file instanceof Blob) return true
  return true
}

/**
 * @param {*} file
 * @returns {boolean}
 */
export function isTradieImportFileExtensionAllowed(file) {
  if (!isTradieImportFileLike(file)) return false
  const name = file.name || ''
  const dot = name.lastIndexOf('.')
  const ext = dot >= 0 ? name.slice(dot + 1).toLowerCase() : ''
  return ext === 'csv' || ext === 'xlsx'
}

/**
 * Client-side checks before multipart upload (type + size).
 * @param {File | Blob | null | undefined} file
 * @returns {{ ok: true } | { ok: false, message: string }}
 */
export function validateTradieImportFile(file) {
  if (!file) {
    return { ok: false, message: 'Please upload a file.' }
  }

  if (!isTradieImportFileLike(file)) {
    return { ok: false, message: 'Please upload a file.' }
  }

  if (!isTradieImportFileExtensionAllowed(file)) {
    return {
      ok: false,
      message: TRADIE_IMPORT_INVALID_TYPE_MESSAGE,
    }
  }

  if (file.size > TRADIE_IMPORT_MAX_FILE_BYTES) {
    return { ok: false, message: 'The file may not be greater than 10 MB.' }
  }

  return { ok: true }
}
